export default __webpack_public_path__ + "static/media/zombie-logo.e04e76c1.svg";